import * as React from "react";
import Component from "../../AbstractComponent";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";

import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import ActivityCreateWillMount from "../../../Middleware/Middlewares/ActivityCreateWillMount";

import Time from "../../../Time/Time";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { ActivityTemplateInterface } from "Casadesk/Entity/Entities/Activity/ActivityTemplateInterface";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";

import IconButton from '@material-ui/core/IconButton';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';


class ActivityCreate extends Component {
  protected activityTemplate: ActivityTemplateInterface;
  protected unitId: number;
  protected propertyId: number;
  public instructionsField;
  protected person: PersonInterface;

  protected middlewares: MiddlewareInterface[] = [
    ActivityCreateWillMount,
    PreventPageLeave
  ];

  public state = {
    name: "",
    selectedEntityForActivity: null,
    ownerId: null,
    tenantId: null,
    reporterId: null,
    subject: "",
    description: "",
    attachments: [],
    amazonFolderName: uuidV4(),
    taskTemplates: [],
    activeTemplate: null,
    activeTemplateId: 0,
    taskToDeleteId: 0,
    isDeleteTaskPopupOpen: false,
    nameEmpty: false,
    errorTemplates: [],
    selectedTaskTemplate: null,
    hasModifiedData: false,
    isSaving: false,
    openLeavePrompt: false,
    nextPath: "",
    tenant: null,
    owner: null,
    openPreTaskExecutorCoachDialog: false,
    executorType: "person",
    executorTypeСhoose: true,
    openTaskExecutorCoachDialog: false,
    clickBackButton: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public selectReporter = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      reporterId: person.id,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null,
      hasModifiedData: true
    });
  }

  public selectEntityForActivity = (entity: PropertyInterface | UnitInterface): void => {
    this.setState({
      selectedEntityForActivityManuallyChanged: true,
      selectedEntityForActivity: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForActivity = (): void => {
    this.setState({
      selectedEntityForActivity: null,
      hasModifiedData: true
    });
  }

  public save = () => {
    const taskTemplates = this.state.taskTemplates
      .filter(template => template.checked === true)
      .map(template => {
        const taskTemplate: any = {
          name: template.name,
          content: {
            name: template.name,
            details: template.details,
          },
          executorId: template.executorId,
          executionDate: template.executionDate ? Time.formatOrNull(template.executionDate) : null,
          snoozeDate: template.executionDate ? Time.formatOrNull(template.executionDate) : null,
          eventTypeId: 35, // task
          reacted: false
        };

        return {
          ...taskTemplate
        }
      });

    if(taskTemplates.some(template => !template.name)) {
      const errorTemplates = [];

      taskTemplates.forEach((template, index) => {
        if(!template.name) {
          errorTemplates.push(index);
        }
      });

      this.setState({errorTemplates: [...errorTemplates]});;

      return;
    }

    const activity: any = {
      eventTypeId: 34,
      reacted: false,
      reporterId: this.state.reporterId,
      content: {
        name: this.state.name,
        subject: this.state.subject,
        description: this.state.description
      },
      amazonFolderName: this.state.amazonFolderName,
      tasks: [...taskTemplates]
    }

    if (this.state.selectedEntityForActivity instanceof Property) {
      activity.propertyId = this.state.selectedEntityForActivity.id;
    }

    if (this.state.selectedEntityForActivity instanceof Unit) {
      activity.unitId = this.state.selectedEntityForActivity.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {
          ...activity
        },
        onSuccess: (activity: EventInterface) => {
          if(this.state.clickBackButton){
            this.redirectBack();
          } else {
            this.setState({
              nextPath: `/app/activity/update/${activity.id}`
            }, this.redirectBack);
          }
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public createTaskTemplate = () => {
    const taskTemplate = {
      name: this.trans("new-task"),
      details: "",
      executorId: null,
      executionDate: null,
      taskTemplateId: null,
      checked: true
    };
    const taskTemplates = [...this.state.taskTemplates];

    const previousTaskTemplate = taskTemplates[taskTemplates.length - 1];
    const previousTaskTemplateName = previousTaskTemplate ? previousTaskTemplate.name : "";
    const previousTaskTemplateNumber = parseInt(previousTaskTemplateName.replace(this.trans("new-task"), ""));
    let newTaskTemplateName = `${this.trans("new-task")} ${previousTaskTemplateNumber + 1}`;


    if (previousTaskTemplateName === this.trans("new-task")) {
      newTaskTemplateName = `${this.trans("new-task")} 2`;
      taskTemplate.name = newTaskTemplateName;
    }

    if (previousTaskTemplateName.includes(this.trans("new-task"))) {
      taskTemplate.name = newTaskTemplateName;
    }

    taskTemplates.push(taskTemplate);
    this.setState({taskTemplates: [...taskTemplates], activeTemplate: {...taskTemplate}, activeTemplateId: taskTemplates.length - 1, hasModifiedData: true});
    if(this.instructionsField){
      this.instructionsField.focus();
    }
  }


  public selectPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = person.id;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: isManuallySelected});
  }

  public clearPerson = (): void => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = null;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public setActivityTemplateName = (event) => {
    const name = event.target.value;

    this.setState({name: name, nameEmpty: false});
  }

  public setTemplateName = (event) => {
    const name = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.name = name;
    templates[this.state.activeTemplateId] = {...template}

    const errorTemplates = [...this.state.errorTemplates];
    errorTemplates.forEach((id, index) => {
      if (id === this.state.activeTemplateId) {
        errorTemplates.splice(index, 1);
      }
    });

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], errorTemplates: [...errorTemplates], hasModifiedData: true});
  }

  public setTemplateDetails = (event) => {
    const details = event.target.value;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.details = details;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: true});
  }

  public setTemplateDays = (event) => {
    const days = Number.parseInt(event.target.value);

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.daysToExecute = days;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates]});
  }

  public deleteTask = (templateId: number) => {
    const templates = [...this.state.taskTemplates];

    templates.splice(templateId, 1);

    const activeTemplate = {...templates[0]};

    this.setState({
      taskTemplates: [...templates],
      activeTemplateId: 0,
      activeTemplate: activeTemplate,
      errorTemplates: [],
      hasModifiedData: true
    });

    if(this.instructionsField){
      this.instructionsField.focus();
    }
  }

  public choosedTaskToDelete = (templateId: number) => {
    const templates = [...this.state.taskTemplates];
    const template = templates.splice(templateId, 1)[0];

    this.setState({isDeleteTaskPopupOpen: true, taskToDeleteId: templateId, selectedTaskTemplate: template})
  }

  public selectDate = (momentDate: any): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executionDate = date;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates]});
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor, isManuallySelected) => {
    const templates = [...this.state.taskTemplates];
    const template = {...templates[this.state.activeTemplateId]};
    template.executorId = executor.id;
    templates[this.state.activeTemplateId] = {...template}

    this.setState({activeTemplate: {...template}, taskTemplates: [...templates], hasModifiedData: isManuallySelected});
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openPreTaskExecutorCoachDialog: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public openTaskExecutorCoach = () => {
    if(this.state.executorType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        openPreTaskExecutorCoachDialog: false,
        openTaskExecutorCoachDialog: true
      })
    } else {
        return this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("coach/executor-scenario/user-step/first-error"),
            type: "error"
          }
        });
    }
  }

  public render() {
    const rightBlockWidth = "340px";
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={() => {this.setState({clickBackButton: true}, this.redirectBack)}}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("new-activity")}</h1>
              <div className="button-container-small">
                <Button
                  color="primary"
                  onClick={this.redirectBack}
                  style={{marginRight: "20px"}}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {this.setState({clickBackButton: false}, this.save)}}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  <div className="read-only-wrapper">
                    <div className="name-field">
                      <div className="margin-wrapper">
					          	  {this.state.name && <div >{`${this.trans("label-type")}: `}</div>}
					              {this.state.selectedEntityForActivity && this.state.selectedEntityForActivity.nameOfEntity && <div>{`${this.state.selectedEntityForActivity.nameOfEntity}: `}</div>}
					          	  {this.state.selectedEntityForActivity && this.state.selectedEntityForActivity instanceof Property ? <div>{`${this.trans("owner")}: `}</div> : this.state.selectedEntityForActivity && (this.state.owner || this.state.tenant) && <div>{`${this.trans("tenant")}: `}</div>}
					              </div>
                      </div>
					            <div className="margin-wrapper">
					          	  {this.state.name && <div>{this.state.name}</div>}
                        {this.state.selectedEntityForActivity && this.state.selectedEntityForActivity.nameOfEntity  && <div>{this.state.selectedEntityForActivity ? `${this.state.selectedEntityForActivity.displayName}` : ""}</div>}
					          	  {this.state.selectedEntityForActivity && (this.state.owner || this.state.tenant) && this.state.selectedEntityForActivity instanceof Property ? <div>{this.state.owner && this.state.owner.name}</div> : <div>{this.state.tenant && this.state.tenant.firstName + this.state.tenant.lastName}</div>}
					            </div>
                  </div>
                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid">
                      <PersonLookup
                        {...this.props}
                        autoSelectId={this.state.reporterId}
                        isInlineBlock={true}
                        width="100%"
                        containerWidth="100%"
                        ref="PersonLookup"
                        floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
                        labelText={this.trans("reported-by") + this.trans("field/optional")}
                        onSelect={this.selectReporter}
                        onClear={this.clearReporter}
                        forceUpdatePage={true}
                        saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "activityCreate", "reporter")}
                        buttonLabel={this.trans("button-add-person")}
                        noResultText={this.trans("dropdown-person-notfound")}
                        templateFor={"person"}
                        includeUsers={true}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-subject"
                        type="text"
                        label={this.trans("subject") + this.trans("field/optional")}
                        value={this.state.subject}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "subject")}
                        autoFocus={true}
                        variant="standard"
                        style={{marginBottom: "10px"}}
                        error={!!this.getErrorFor("subject")}
                      />
                      {!!this.getErrorFor("subject") && <div className="component-error-text">{this.getErrorFor("subject")}</div>}

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-description"
                        type="text"
                        label={this.trans("description") + this.trans("field/optional")}
                        value={this.state.description}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "description")}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        error={!!this.getErrorFor("description")}
                      />
                      {!!this.getErrorFor("description") && <div className="component-error-text">{this.getErrorFor("description")}</div>}
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <div className="component">
                <Card className="card no-padding">
                  <div className="label-container">
                    <h3 className="card-title">
                      {this.trans("tasks")}
                    </h3>
                    <Button
                      color="primary"
                      className="add-task"
                      onClick={this.createTaskTemplate}
                    >
                      {this.trans("new-task")}
                    </Button>
                  </div>
                  <div className="task-tempalte-wrapper" style={{display: "flex", paddingTop: "20px"}}>
                    <div className="left-block"
                      style={{
                        minHeight: "300px",
                        width: "30%",
                        borderRight: "1px solid rgba(0, 0, 0, 0.1)",
                        borderTop: "1px solid rgba(0, 0, 0, 0.1)"
                      }}
                    >
                      {
                        this.state.taskTemplates.length === 0 && (
                          <div
                            style={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center"
                            }}
                          >
                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "8px"}}>
                              <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                            </div>
                            <div style={{fontSize: "22px", fontWeight: "bold", color: "#dcdbdc", marginBottom: "8px"}}>{this.trans("no-tasks-created")}</div>
                          </div>
                        )
                      }
                      {
                        this.state.taskTemplates.length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flex-start"
                            }}
                          >
                            {
                              this.state.taskTemplates
                              .map((taskTemplate, key: number) => {
                                return (
                                  <div key={key} className={this.state.activeTemplateId === key ? "with-active-gray-background" : "with-active-white-background"}
                                    style={{
                                      borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      cursor: "pointer",
                                      backgroundColor: this.state.errorTemplates.some(index => index === key) ? "#ffa4a4" : "",
                                      width: "100%",
                                    }}
                                  >
                                    <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center", cursor: "pointer", width: "100%", backgroundColor: "inherit"}} onClick={() => {
                                      this.setState({activeTemplate: {...taskTemplate}, activeTemplateId: key});
                                        if(this.instructionsField){
                                          this.instructionsField.focus();
                                        }
                                      }}>
                                      <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginRight: "22px", marginLeft: "22px"}}>
                                        <div className="icon icon-ic-task" style={{color: "#dcdbdc"}}></div>
                                      </div>
                                      <div style={{fontSize: "14px", color: "#404040", lineHeight: "24px"}}>{taskTemplate.name}</div>
                                    </div>
                                    <div
                                      onClick={() => this.choosedTaskToDelete(key)}
                                      style={{display: "flex", alignItems: "center", justifyContent: "center", width: "50px", height: "48px"}}>
                                      <IconButton  aria-label="Delete" className="icon-button-wrapper">
                                        <div className="icon icon-ic-remove"></div>
                                      </IconButton>
                                    </div>
                                  </div>
                                );
                              })
                            }
                          </div>
                        )
                      }
                    </div>
                    <div className="right-block" style={{paddingLeft: "20px"}}>
                      {this.state.taskTemplates.length > 0 && (
                        <div style={{width: rightBlockWidth}}>
                          <TextField
                            autoComplete="off"
                            className="form-element full-size"
                            type="text"
                            label={this.trans("label-description")}
                            value={this.state.activeTemplate ? this.state.activeTemplate.name : ""}
                            onChange={this.setTemplateName}
                            autoFocus={true}
                            inputRef={(input) => { this.instructionsField = input; }}
                            variant="standard"
                            multiline
                            rowsMax="25"
                            rows="1"
                            error={this.state.errorTemplates.some(index => index === this.state.activeTemplateId) && !!this.trans("this-field-is-required")}
                          />
                          {this.state.errorTemplates.some(index => index === this.state.activeTemplateId) && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

                          <div style={{margin: "-10px 0"}}>
                            <PersonLookup
                              {...this.props}
                              isInlineBlock={true}
                              ref="PersonLookup"
                              width={rightBlockWidth}
                              floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
                              labelText={this.trans("to-do-by") + this.trans("field/optional")}
                              onSelect={this.selectPerson}
                              onClear={this.clearPerson}
                              autoSelectId={this.state.activeTemplate.executorId}
                              buttonLabel={this.trans("button-add-executor")}
                              noResultText={this.trans("textfield-no-executor-found-click-add")}
                              templateFor={"executor"}
                              includeUsers={true}
                              saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "activityCreate", "executor")}
                              shouldOpenCoachModal={true}
                              openTaskExecutorCoachDialog={() => this.setState({openPreTaskExecutorCoachDialog: true})}
                            />
                          </div>

                          <DatePickerComponent
                            {...this.props}
                            className="scroll-to-executionDate"
                            label={this.trans("show-me-from") + this.trans("field/optional")}
                            initialDate={this.state.activeTemplate ? this.state.activeTemplate.executionDate : null}
                            onChange={date => this.selectDate(date)}
                            minDate={new Date()}
                            minDatePlusDays={0}
                            clearButton={true}
                            error={this.getErrorFor("executionDate")}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Card>
              </div>
            </div>
            <div className="component-wrapper no-shadow">
            <Attachment
              {...this.props}
              typeOfComponent="shared"
              title={this.trans("attachments-for-activity")}
              relation="eventId"
              onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
              amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
              attachments={this.state.attachments}
              updateParentState={attachments => this.setState({attachments: attachments})}
              onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
              onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            />
          </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", {name: this.state.selectedTaskTemplate && this.state.selectedTaskTemplate.name ? this.state.selectedTaskTemplate.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteTaskPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteTaskPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteTaskPopupOpen: false }); this.deleteTask(this.state.taskToDeleteId) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/executor-title")}
          content={this.getCoachContent()}
          innerDialogClasses="dialog-assistant coach-executor"
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPreTaskExecutorCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPreTaskExecutorCoachDialog: false,
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={this.openTaskExecutorCoach}
          // diableContinueButton={!this.state.ownerTypeСhose}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.activityCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ActivityCreate
);
